import React, { useEffect, useState } from 'react';
import { bindFormChange } from '../SiteUtil';
import { useUser } from '../hooks';
import { Modal, Input, Field, Message, Button, Toast } from 'react-frontier';
import { WorkerTitle, SetLoading, EventWorker } from '../SiteClasses';
import SearchTitleModal from './SearchTitleModal';
import SearchAvailableWorkerModal from './SearchAvailableWorkerModal';
import Validator from '../Validator';
import moment from 'moment';
import API from '../API';

interface Form{
	date_id: number,
	worker_id: number,
	worker_name: string,
	title_id?: number,
	title_name?: string,
	description: string,
	payout_amount: number,
	zipcode?: string,
}

interface ModalProps{
	open: boolean,
	date_id: number,
	onClose: ()=>void,
	onAdded?: (worker: EventWorker)=>void
	onUpdated?: (worker: EventWorker)=>void
	workerToEdit?: EventWorker,
}

var AddWorkerModal = (props: ModalProps)=>{
	var { user } = useUser();
	var [searchAvailableWorkersModal, setSearchAvailableWorkersModal] = useState<boolean>(false);
	var [searchTitleModal, setSearchTitleModal] = useState<boolean>(false);
	var [modalPrompts, setModalPrompts] = useState<string[]>(null);
	var [isEditing, setIsEditing] = useState<boolean>(false);
	var [form, setForm] = useState<Form>(null);

	useEffect(()=>{
		if(props.open){
			var editingMode = Boolean(props.workerToEdit);
			setIsEditing(editingMode);

			if(editingMode){
				setForm({
					date_id: props.date_id,
					worker_id: props.workerToEdit.worker_id,
					worker_name: props.workerToEdit.worker_name,
					title_id: props.workerToEdit.title_id,
					title_name: props.workerToEdit.title_name,
					description: props.workerToEdit.description,
					payout_amount: props.workerToEdit.payout_amount,
				});
			}else{
				setForm({
					date_id: props.date_id,
					worker_id: null,
					worker_name: '',
					title_id: null,
					title_name: '',
					description: '',
					payout_amount: null,
				});
			}
		}
	}, [props.open, props.workerToEdit]);

	var selectAvailableWorker = (worker: any)=>{
		setForm(prev => ({
			...prev,
			worker_id: worker.worker_id,
			worker_name: worker.worker_name,
		}));
		setSearchAvailableWorkersModal(false);
	};

	var selectTitle = (title: WorkerTitle)=>{
		setForm(prev => ({
			...prev,
			title_id: title.title_id,
			title_name: title.title_name,
			payout_amount: title.payout_amount
		}));
		setSearchTitleModal(false);
	};

	var submit = (setLoading: SetLoading)=>{
      var { valid, prompts } = Validator(form, {
         worker_id: [{
            rule: 'empty', prompt: 'Favor de seleccionar al trabajador'
         }],
         payout_amount: [
				{ rule: 'number', prompt: 'El sueldo del trabajador debe ser un número' },
				{ rule: 'min', params: [1], skipEmpty: true, prompt: 'Favor de ingresar el sueldo del trabajador' },
			],
			
			
			
      });
      setModalPrompts(prompts);
      if (!valid) return;  
      setLoading(true);
      
		if(isEditing && props.workerToEdit){
			API.editEventWorker(form.date_id, form.worker_id, form.title_id,  form.description, form.payout_amount).then(res=>{
				if(res.error) return setModalPrompts([res.message]);
				Toast.success('Trabajador actualizado!');
				var updatedWorker: EventWorker = {
					date_id: form.date_id,
					worker_id: form.worker_id,
					worker_name: form.worker_name,
					title_id: form.title_id,
					title_name: form.title_name,
					description: form.description,
					payout_amount: form.payout_amount,
					user_creator: props.workerToEdit.user_creator,
					user_creator_name: props.workerToEdit.user_creator_name,
					user_cancelled: props.workerToEdit.user_cancelled,
					date_created: props.workerToEdit.date_created,
					rating: props.workerToEdit.rating,
					rating_comment: props.workerToEdit.rating_comment,
					user_rated: props.workerToEdit.user_rated,
					user_rated_name: props.workerToEdit.user_rated_name,
					date_rated: props.workerToEdit.date_rated,
				};
				props.onUpdated(updatedWorker);
			}).catch(err=>{
				setModalPrompts(['Hubo un error inesperado actualizando el trabajador (LCL-1)']);
			}).finally(()=>{
				setLoading(false);
			});
		}else{
			API.addEventWorker(form.date_id, form.worker_id, form.title_id,  form.description, form.payout_amount).then(res=>{
				if (res.error) return setModalPrompts([res.message]);
				Toast.success(`Traabajador agregado!`);

				var newWorker: EventWorker={
					date_id: form.date_id,
					worker_id: form.worker_id,
					worker_name: form.worker_name,
					title_id: form.title_id,
					title_name: form.title_name,
					description: form.description,
					payout_amount: form.payout_amount,
					user_creator: user.user_id,
					user_creator_name: user.name,
					date_created:  moment().unix(),
				};
				props.onAdded(newWorker);
			}).catch(err=>{
				setModalPrompts(['Hubo un error inesperado agregando el trabajador (LCL-1)']);
			}).finally(()=>{
				setLoading(false);
			});
		}
   }

	var onFormChange = bindFormChange(form, setForm);

	return <>
		<Modal open={props.open} onClose={props.onClose} size='tiny'>
			<Modal.Header>{isEditing ? 'Editar' : 'Agregar'} trabajador</Modal.Header>
			{!!form && (
				<Modal.Content>
					<Field label='Trabajador'>
						<Input readonly
							value={form.worker_name}
							placeholder='Selecciona un trabajador...'
							button={!isEditing ? (
								<Button 
									text='Buscar' 
									onClick={() => setSearchAvailableWorkersModal(true)}
								/>
							) : null}
						/>
					</Field>
					<Field label='Puesto'>
						<Input readonly
							value={form.title_name}
							placeholder='Selecciona un puesto...'
							button={
								<Button text='Seleccionar' onClick={() => setSearchTitleModal(true)} />
							}
						/>
					</Field>
					<Input label='Sueldo' value={form.payout_amount} onChange={onFormChange('payout_amount')} inputType='number'/>
					<Input label='Descripción' comment='Opcional' value={form.description} onChange={onFormChange('description')} textarea/>
					<Message style={{ marginTop: 15 }} type='error' list={modalPrompts} />
				</Modal.Content>
			)}
			<Modal.Actions>
				<Button basic text='Cerrar' onClick={props.onClose} />
				<Button color="black" text={isEditing ? 'Guardar' : 'Agregar'} onClick={submit}/>
			</Modal.Actions>
		</Modal>
		<SearchAvailableWorkerModal
			open={searchAvailableWorkersModal}
			onClose={() => setSearchAvailableWorkersModal(false)}
			onSelected={selectAvailableWorker}
			date_id={props.date_id}
		/>
		<SearchTitleModal
			open={searchTitleModal}
			onClose={() => setSearchTitleModal(false)}
			onSelected={selectTitle}
		/>
	</>
}

export default AddWorkerModal;